module.exports = "/assets/data/92b3d1481da7e41376c0452d05c2a565-CA3.data.json";